// @ts-nocheck
import gunilBioPharm from './건일바이오팜';
import kyungdongPharm from './경동제약';
import koryoPharm from './고려';
import kwangdongPharm from './광동제약';
import kukjePharm from './국제약품';
import dasanPharm from './다산제약';
import daewooPharm from './대우';
import daewoongBio from './대웅바이오';
import dhnpPharm from './대한뉴팜';
import daehwaPharm from './대화제약';
import donggwangPharm from './동광제약';
import dongkooBio from './동구바이오';
import donggukPharm from './동국제약';
import dongsungPharm from './동성제약';
import risingPharm from './라이징팜';
import lohasMedi from './로하스메디';
import macnultyPharm from './맥널티제약';
import medigenHealthcare from './메디젠헬스케어';
import medicaKorea from './메디카코리아';
import baskanBio from './바스칸바이오';
import binexPharm from './바이넥스';
import bibozonPharm from './비보존';
import samsungPharm from './삼성제약';
import samikPharm from './삼익제약';
import seoulPharm from './서울제약';
import shinilPharm from './신일제약';
import ajuPharm from './아주약품';
import alicoPharm from './알리코';
import ahnkookNewPharm from './안국뉴팜';
import ahnkookPharm from './안국약품';
import hlbPharm from './에이치엘비제약';
import aprogenBio from './에이프로젠BIO';
import lncMediCare from './엘앤씨메디케어';
import youngilPharm from './영일제약';
import youngjinPharm from './영진약품';
import austinPharm from './오스틴';
import oscoreaPharm from './오스코리아제약';
import optusPharm from './옵투스';
import withusPharm from './위더스제약';
import unimedPharm from './유니메드';
import yooyoungPharm from './유영제약';
import yuyuPharm from './유유제약';
import edenPharma from './이든파마';
import ilsunIS from './일성아이에스';
import ilhwaPharm from './일화';
import genewonSciences from './제뉴원사이언스';
import glPharma from './지엘파마';
import jinyangPharm from './진양제약';
import ksPharm from './케이에스제약';
import kmsPharm from './케이엠에스';
import kolonPharm from './코오롱';
import kimsPharm from './킴스제약';
import kipsBioPharma from './킵스바이오파마';
import teragenEtex from './테라젠이텍스';
import pharmascience from './파마사이언스';
import pharmGenSciences from './팜젠사이언스';
import koreaMedix from './한국메딕스';
import koreaPharma from './한국파마';
import koreaPrimePharm from './한국프라임제약';
import koreaHutecsPharm from './한국휴텍스제약';
import hanolBioPharm from './한올바이오파마';
import whiteLifeScience from './화이트생명과학';
import hwibisPharm from './휴비스트제약';
import huonsPharm from './휴온스';
import huonsMeditech from './휴온스메디텍';
import cmgPharm from './CMG제약';
import ctcBio from './CTC바이오';

function flattenCommissionTemplates(mod) {
  const value = mod?.default ?? mod;
  if (Array.isArray(value)) {
    return value;
  }
  if (value && typeof value.match === 'function') {
    return [value];
  }
  return [];
}

const commissionTemplates = [
  ...flattenCommissionTemplates(gunilBioPharm),
  ...flattenCommissionTemplates(kyungdongPharm),
  ...flattenCommissionTemplates(koryoPharm),
  ...flattenCommissionTemplates(kwangdongPharm),
  ...flattenCommissionTemplates(kukjePharm),
  ...flattenCommissionTemplates(dasanPharm),
  ...flattenCommissionTemplates(daewooPharm),
  ...flattenCommissionTemplates(daewoongBio),
  ...flattenCommissionTemplates(dhnpPharm),
  ...flattenCommissionTemplates(daehwaPharm),
  ...flattenCommissionTemplates(donggwangPharm),
  ...flattenCommissionTemplates(dongkooBio),
  ...flattenCommissionTemplates(donggukPharm),
  ...flattenCommissionTemplates(dongsungPharm),
  ...flattenCommissionTemplates(risingPharm),
  ...flattenCommissionTemplates(lohasMedi),
  ...flattenCommissionTemplates(macnultyPharm),
  ...flattenCommissionTemplates(medigenHealthcare),
  ...flattenCommissionTemplates(medicaKorea),
  ...flattenCommissionTemplates(baskanBio),
  ...flattenCommissionTemplates(binexPharm),
  ...flattenCommissionTemplates(bibozonPharm),
  ...flattenCommissionTemplates(samsungPharm),
  ...flattenCommissionTemplates(samikPharm),
  ...flattenCommissionTemplates(seoulPharm),
  ...flattenCommissionTemplates(shinilPharm),
  ...flattenCommissionTemplates(ajuPharm),
  ...flattenCommissionTemplates(alicoPharm),
  ...flattenCommissionTemplates(ahnkookNewPharm),
  ...flattenCommissionTemplates(ahnkookPharm),
  ...flattenCommissionTemplates(hlbPharm),
  ...flattenCommissionTemplates(aprogenBio),
  ...flattenCommissionTemplates(lncMediCare),
  ...flattenCommissionTemplates(youngilPharm),
  ...flattenCommissionTemplates(youngjinPharm),
  ...flattenCommissionTemplates(austinPharm),
  ...flattenCommissionTemplates(oscoreaPharm),
  ...flattenCommissionTemplates(optusPharm),
  ...flattenCommissionTemplates(withusPharm),
  ...flattenCommissionTemplates(unimedPharm),
  ...flattenCommissionTemplates(yooyoungPharm),
  ...flattenCommissionTemplates(yuyuPharm),
  ...flattenCommissionTemplates(edenPharma),
  ...flattenCommissionTemplates(ilsunIS),
  ...flattenCommissionTemplates(ilhwaPharm),
  ...flattenCommissionTemplates(genewonSciences),
  ...flattenCommissionTemplates(glPharma),
  ...flattenCommissionTemplates(jinyangPharm),
  ...flattenCommissionTemplates(ksPharm),
  ...flattenCommissionTemplates(kmsPharm),
  ...flattenCommissionTemplates(kolonPharm),
  ...flattenCommissionTemplates(kimsPharm),
  ...flattenCommissionTemplates(kipsBioPharma),
  ...flattenCommissionTemplates(teragenEtex),
  ...flattenCommissionTemplates(pharmascience),
  ...flattenCommissionTemplates(pharmGenSciences),
  ...flattenCommissionTemplates(koreaMedix),
  ...flattenCommissionTemplates(koreaPharma),
  ...flattenCommissionTemplates(koreaPrimePharm),
  ...flattenCommissionTemplates(koreaHutecsPharm),
  ...flattenCommissionTemplates(hanolBioPharm),
  ...flattenCommissionTemplates(whiteLifeScience),
  ...flattenCommissionTemplates(hwibisPharm),
  ...flattenCommissionTemplates(huonsPharm),
  ...flattenCommissionTemplates(huonsMeditech),
  ...flattenCommissionTemplates(cmgPharm),
  ...flattenCommissionTemplates(ctcBio),
];

function normalizeFileStem(fileName = '') {
  return String(fileName)
    .normalize('NFC')
    .replace(/\.[^.]+$/i, '')
    .replace(/\s+/g, '')
    .toLowerCase();
}

function getCommissionTemplatesForFileName(fileName = '') {
  const stem = normalizeFileStem(fileName);
  if (!stem) {
    return [];
  }

  return commissionTemplates.filter((template) => {
    const pharma = normalizeFileStem(template.pharmaceuticalCompanyName);
    return pharma && stem.includes(pharma);
  });
}

function getOrderedCommissionTemplates(context) {
  const hinted = getCommissionTemplatesForFileName(context?.file?.name || '');
  if (!hinted.length) {
    return commissionTemplates;
  }

  const hintedIds = new Set(hinted.map((template) => template.id));
  const rest = commissionTemplates.filter(
    (template) => !hintedIds.has(template.id),
  );
  return [...hinted, ...rest];
}

/**
 * 제약사 템플릿 매칭 (시트 → 고정 헤더행)
 * 1. targetSheetName 시트 존재
 * 2. headerRowIndex 행이 requiredHeaders와 대부분 일치
 * 파일명에 제약사명이 있으면 해당 템플릿을 먼저 시도합니다.
 */
function resolveCommissionTemplate(context) {
  for (const template of getOrderedCommissionTemplates(context)) {
    if (template.match(context)) {
      return template;
    }
  }

  return null;
}

export {
  commissionTemplates,
  resolveCommissionTemplate,
  getCommissionTemplatesForFileName,
  getOrderedCommissionTemplates,
  normalizeFileStem,
};
